module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-red.95f0b6b2.svg";